import { type MouseEvent } from 'react';

import CheckmarkIcon from '@cartwhl/ui/icons/CheckmarkIcon';

const SELECTION_CONTROL_CLASS =
  'absolute top-2 left-2 z-10 flex h-5 w-5 cursor-pointer items-center justify-center rounded-sm shadow-sm';

export interface AssetLibraryCardSelectionControlProps {
  selected: boolean;
  visible: boolean;
  onToggle: () => void;
}

export default function AssetLibraryCardSelectionControl({
  selected,
  visible,
  onToggle,
}: AssetLibraryCardSelectionControlProps) {
  const showControl = visible || selected;

  const stopBubble = (event: MouseEvent) => {
    event.stopPropagation();
  };

  const visibilityClass = `transition-opacity duration-200 ease-out ${
    showControl ? 'opacity-100' : 'pointer-events-none opacity-0'
  }`;

  if (selected) {
    return (
      <button
        type="button"
        aria-label="Deselect asset"
        aria-pressed
        className={`${SELECTION_CONTROL_CLASS} bg-blue ${visibilityClass}`}
        onClick={(event) => {
          stopBubble(event);
          onToggle();
        }}
        onMouseDown={stopBubble}
      >
        <CheckmarkIcon className="h-4 w-4 text-white" />
      </button>
    );
  }

  return (
    <button
      type="button"
      aria-label="Select asset"
      aria-pressed={false}
      className={`${SELECTION_CONTROL_CLASS} border-secondary bg-primary border ${visibilityClass}`}
      onClick={(event) => {
        stopBubble(event);
        onToggle();
      }}
      onMouseDown={stopBubble}
    />
  );
}
